export default function Highlights() {
  const highlights = [
    {
      title: 'Trân Châu Cảng',
      description: 'Dấu ấn lịch sử Thế chiến II - Chiến hạm USS Arizona - Bảo tàng hải quân',
      image: 'https://public.readdy.ai/ai/img_res/97b7c26ede6570c00de14d3d604c4ae9.jpg',
      icon: 'ri-ship-line',
      color: 'from-blue-600 to-cyan-500'
    },
    {
      title: 'Trung tâm Polynesian',
      description: 'Văn hóa truyền thống - Show biểu diễn đặc sắc - Ẩm thực bản địa',
      image: 'https://readdy.ai/api/search-image?query=Vibrant%20Polynesian%20Cultural%20Center%20performance%20in%20Hawaii%20with%20traditional%20dancers%20in%20colorful%20costumes%2C%20fire%20dancers%2C%20tropical%20setting%2C%20cultural%20show%20on%20stage%2C%20authentic%20Hawaiian%20luau%20atmosphere%2C%20evening%20lighting%2C%20professional%20event%20photography%2C%20simple%20tropical%20background&width=600&height=400&seq=polynesian-1&orientation=landscape',
      icon: 'ri-music-2-line',
      color: 'from-teal-600 to-green-500'
    },
    {
      title: 'Vịnh Hanauma',
      description: 'Lặn biển ngắm san hô - Rùa biển - Cá nhiệt đới - Thiên đường dưới nước',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Hanauma%20Bay%20Hawaii%20with%20crystal%20clear%20turquoise%20water%2C%20coral%20reef%20visible%20underwater%2C%20curved%20beach%20with%20white%20sand%2C%20snorkelers%20swimming%2C%20tropical%20fish%2C%20volcanic%20crater%20bay%2C%20pristine%20nature%20reserve%2C%20professional%20travel%20photography%2C%20simple%20ocean%20background&width=600&height=400&seq=hanauma-1&orientation=landscape',
      icon: 'ri-water-flash-line',
      color: 'from-cyan-600 to-blue-500'
    },
    {
      title: 'Lỗ phun khí Halona',
      description: 'Hiện tượng tự nhiên kỳ thú - Sóng biển mạnh - Cảnh đẹp ngoạn mục',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20Halona%20Blowhole%20in%20Hawaii%20with%20powerful%20ocean%20water%20shooting%20high%20into%20air%20through%20volcanic%20rock%20formation%2C%20crashing%20waves%2C%20rugged%20coastal%20cliffs%2C%20blue%20Pacific%20Ocean%2C%20natural%20wonder%2C%20spectacular%20spray%2C%20professional%20nature%20photography%2C%20simple%20coastal%20background&width=600&height=400&seq=halona-1&orientation=landscape',
      icon: 'ri-water-percent-line',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      title: 'Bãi biển Sandy',
      description: 'Thiên đường lướt sóng - Sóng lớn - Bãi cát trắng mịn - Bodyboarding',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20Sandy%20Beach%20Hawaii%20with%20powerful%20waves%20perfect%20for%20bodysurfing%2C%20white%20sand%20beach%2C%20surfers%20riding%20big%20waves%2C%20turquoise%20ocean%20water%2C%20palm%20trees%2C%20tropical%20paradise%2C%20action%20sports%20photography%2C%20golden%20sunlight%2C%20simple%20beach%20background&width=600&height=400&seq=sandy-beach-1&orientation=landscape',
      icon: 'ri-surfboard-line',
      color: 'from-orange-500 to-yellow-500'
    },
    {
      title: 'Đài quan sát Pali',
      description: 'View toàn cảnh Oahu - Núi xanh - Biển xanh - Gió mạnh - Cảnh đẹp tuyệt vời',
      image: 'https://readdy.ai/api/search-image?query=Breathtaking%20panoramic%20view%20from%20Pali%20Lookout%20in%20Oahu%20Hawaii%2C%20dramatic%20green%20mountain%20cliffs%2C%20windward%20coast%20vista%2C%20turquoise%20ocean%20in%20distance%2C%20lush%20tropical%20valleys%2C%20cloudy%20sky%2C%20scenic%20overlook%2C%20professional%20landscape%20photography%2C%20simple%20mountain%20background&width=600&height=400&seq=pali-1&orientation=landscape',
      icon: 'ri-landscape-line',
      color: 'from-green-600 to-teal-500'
    },
    {
      title: 'Núi lửa Đảo Lớn',
      description: 'Công viên núi lửa quốc gia - Dung nham đỏ rực - Miệng núi lửa hoạt động',
      image: 'https://readdy.ai/api/search-image?query=Active%20volcano%20on%20Big%20Island%20Hawaii%20with%20glowing%20red%20lava%20flows%2C%20volcanic%20crater%2C%20molten%20lava%20rivers%2C%20steam%20rising%2C%20dramatic%20volcanic%20landscape%2C%20night%20photography%20with%20lava%20glow%2C%20geological%20wonder%2C%20professional%20nature%20photography%2C%20simple%20volcanic%20background&width=600&height=400&seq=volcano-1&orientation=landscape',
      icon: 'ri-fire-line',
      color: 'from-red-600 to-orange-500'
    },
    {
      title: 'Bãi cát đen & xanh',
      description: 'Bãi biển độc đáo - Cát núi lửa - Rùa biển xanh - Phong cảnh kỳ lạ',
      image: 'https://readdy.ai/api/search-image?query=Unique%20black%20sand%20beach%20on%20Big%20Island%20Hawaii%20with%20volcanic%20black%20sand%2C%20green%20sea%20turtles%20resting%20on%20shore%2C%20turquoise%20ocean%20waves%2C%20palm%20trees%2C%20dramatic%20contrast%2C%20rare%20natural%20phenomenon%2C%20professional%20travel%20photography%2C%20simple%20beach%20background&width=600&height=400&seq=black-sand-1&orientation=landscape',
      icon: 'ri-contrast-2-line',
      color: 'from-gray-700 to-gray-900'
    },
    {
      title: 'Maui Big Beach',
      description: 'Bãi biển đẹp nhất Maui - Ngắm cá voi - Lahaina - Hoàng hôn lãng mạn',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20Big%20Beach%20Makena%20in%20Maui%20Hawaii%20with%20wide%20white%20sand%20beach%2C%20crystal%20clear%20turquoise%20water%2C%20whale%20watching%20in%20distance%2C%20palm%20trees%2C%20golden%20sunset%2C%20romantic%20tropical%20paradise%2C%20professional%20beach%20photography%2C%20simple%20ocean%20background&width=600&height=400&seq=maui-beach-1&orientation=landscape',
      icon: 'ri-sun-line',
      color: 'from-yellow-500 to-orange-500'
    },
    {
      title: 'Đường đến Hana',
      description: 'Cung đường đẹp nhất Hawaii - 600+ khúc cua - Thác nước - Rừng nhiệt đới',
      image: 'https://readdy.ai/api/search-image?query=Scenic%20winding%20Road%20to%20Hana%20in%20Maui%20Hawaii%20with%20lush%20tropical%20rainforest%2C%20cascading%20waterfalls%20along%20roadside%2C%20dramatic%20coastal%20views%2C%20narrow%20bridges%2C%20verdant%20jungle%2C%20misty%20mountains%2C%20most%20beautiful%20drive%2C%20professional%20travel%20photography%2C%20simple%20forest%20background&width=600&height=400&seq=hana-road-1&orientation=landscape',
      icon: 'ri-road-map-line',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section id="highlights" className="py-20 bg-gradient-to-b from-[#eff6ff] to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Điểm nổi bật <span className="text-[#2563eb]">Hawaii</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Khám phá những địa điểm tuyệt đẹp và độc đáo nhất quần đảo Hawaii
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {highlights.map((highlight, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={highlight.image}
                  alt={highlight.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${highlight.color} opacity-40 group-hover:opacity-50 transition-opacity duration-300`}></div>
                
                {/* Icon */}
                <div className="absolute top-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-xl flex items-center justify-center shadow-lg">
                  <i className={`${highlight.icon} text-2xl bg-gradient-to-r ${highlight.color} bg-clip-text text-transparent`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{highlight.title}</h3>
                <p className="text-gray-600 leading-relaxed">{highlight.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#gallery"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-[#2563eb] to-[#3b82f6] text-white rounded-full font-bold text-lg hover:shadow-xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Xem tất cả các điểm nổi bật
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
